import { render, staticRenderFns } from "./BookingFormTextarea.vue?vue&type=template&id=6656494c&scoped=true&"
import script from "./BookingFormTextarea.vue?vue&type=script&lang=js&"
export * from "./BookingFormTextarea.vue?vue&type=script&lang=js&"
import style0 from "./BookingFormTextarea.vue?vue&type=style&index=0&id=6656494c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6656494c",
  null
  
)

export default component.exports